import "components/jiffy/transfer-guides/transfer-guides";

import "./product-details-info-left.scss";

const $getProductDetailsSavingsItem = () =>
  document.querySelectorAll(".js-product-details-savings-item");
const $getProductDetailsBulkDiscountItem = () =>
  document.querySelectorAll(".js-product-details-bulk-discount");
const $getToggle = () =>
  document.querySelector(".js-product-details-info-left__bulk-discount-toggle");
const $getInfoLeftContainer = () => document.querySelector(".js-info-left");
const $getProductDetailsContainer = () => document.querySelector(".js-product-details-info");

const handleBulkDiscountTable = () => {
  const $items = [...$getProductDetailsSavingsItem(), ...$getProductDetailsBulkDiscountItem()];
  $items.forEach($item => {
    const { jiffyPrint } = $item.dataset;
    if (jiffyPrint && jiffyPrint !== "blanks") return;
    $item.classList.remove("hidden");
  });
};

const initToggle = () => {
  const $toggle = $getToggle();

  if (!$toggle) return;

  $toggle.addEventListener("click", () => {
    document
      .querySelectorAll($toggle.dataset.target)
      .forEach($target => $target.classList.toggle("show"));
  });
};

const checkStickyProduct = () => {
  const $productDetailsContainer = $getProductDetailsContainer();
  const $infoLeftContainer = $getInfoLeftContainer();
  if (!$productDetailsContainer || !$infoLeftContainer) return;

  const isSticky = $infoLeftContainer.dataset.sticky === "true";
  if (!isSticky) return;

  const productDetailsContainerRect = $productDetailsContainer.getBoundingClientRect();
  $productDetailsContainer.style.minHeight = `${productDetailsContainerRect.height}px`;
  $infoLeftContainer.classList.add("lg:!sticky", "lg:top-[60px]", "lg:z-2");
};

export default () => {
  initToggle();

  handleBulkDiscountTable();
  checkStickyProduct();
};
